import { createContext, useContext } from 'react';

import { scale as initialScale } from '@components/frame';
import { font as initialFont } from '@styles/fonts';
import { ScaleFunction } from '@components/operatorPanel/interfaces';

interface EditorConfig {
  scale: ScaleFunction;
  font: typeof initialFont;
}

const EditorConfigContext = createContext<EditorConfig>({
  scale: initialScale,
  font: initialFont,
});

export const useEditorConfig = () => useContext(EditorConfigContext);

export default EditorConfigContext;
